// extracted by mini-css-extract-plugin
export var triangle = "styles-module--triangle--f9c3a";
export var triangle1 = "styles-module--triangle1--f99ef";
export var triangle2 = "styles-module--triangle2--81535";
export var triangle3 = "styles-module--triangle3--21049";
export var triangle4 = "styles-module--triangle4--2ac98";